<article class="snackBar">
  <mat-icon class="snackBar__icon" *ngIf="icon">{{ icon }}</mat-icon>
  <article class="snackBar__detail detail">
    <span class="detail__message">{{ message }}</span>
    <span *ngIf="action" class="detail__action" (click)="actionClick()">{{
      action
    }}</span>
  </article>
</article>
